import { TermsCondtionsComponent } from '../auth/terms-condtions/terms-condtions.component';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OnBoardingComponent } from '../auth/on-boarding/on-boarding.component';
import { LoginComponent } from '../login/login.component';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { UtilsService } from 'src/app/core/services/utils.service';
import { SignUp } from 'src/app/core/interface/auth.model';
import { AuthService } from '../../core/services/auth.service';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { NgxSpinnerService } from "ngx-spinner";
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { DisclaimerComponent } from '../auth/disclaimer/disclaimer.component';
import { PrivacyPolicyComponent } from '../auth/privacy-policy/privacy-policy.component';
import { FacebookLoginProvider, AuthService as LoginServce } from 'angularx-social-login';
import { SignUpComponent } from '../auth/sign-up/sign-up.component';
import { ChatService } from 'src/app/core/services/chat.service';
import { Router } from '@angular/router';
import { ErrorMessageComponent } from '../all-modals/error-message/error-message.component';
import {LeminCroppedCaptchaComponent} from "@leminnow/ng-lemin-cropped-captcha";

declare var OneSignal: any
declare let fbq: Function;

@Component({
  selector: 'app-joinnow',
  templateUrl: './joinnow.component.html',
  styleUrls: ['./joinnow.component.scss']
})
export class JoinnowComponent implements OnInit {
  type: any = 'confirm';
  signupForm: FormGroup;

  errorMessage: string;

  submitted: boolean = false;
  isError: boolean = false;

  separateDialCode = true;
  password = 'password';
  cpassword = 'password';
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  userData: any;
  playerId: any = '';
  redirectUrl = '/dashboard';
  userObj = {
    id: '',
    name: '',
    username: '',
    email: '',
    author: {}
  };
  isCaptchaVerified: boolean = false

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private utilService: UtilsService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private loginService: LoginServce,
    private router: Router,
    private chatService: ChatService,
  ) { }

  ngOnInit() {

    this.signupForm = this.formBuilder.group({
      // name: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.NAME_PATTERN), this.noWhitespaceValidator, Validators.maxLength(45)])],
      name: ['',Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.BUISNESS_NAME_PATTERN), this.noWhitespaceValidator, Validators.maxLength(45)])],

      email: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.EMAIL_PATTERN)])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern(REGEX_PATTERNS.PASSWORD_PATTERN), this.noWhitespaceValidator])],
      password_confirmation: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.PASSWORD_PATTERN), this.noWhitespaceValidator])],
    }, {
      validator: this.utilService.mustMatch('password', 'password_confirmation')
    });
  }
  closeDialog() {
    this.activeModal.close();
  }

  openConfirmEmail() {

    const modalRef = this.modalService.open(SignUpComponent, {
      // size: "sm",
      centered: true,
      // backdrop: false,
      keyboard: false
    });
    modalRef.componentInstance.type = 'confirm';
    modalRef.componentInstance.createdUser = this.userData;
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  verifyCallback(isVerified: boolean) {
    if (isVerified === true) {
      this.isCaptchaVerified = true;
      console.log("Captcha verification is", isVerified)
    } else {
      console.log("Captcha verification is", isVerified)
    }
  }

  openOnboardModal() {
    this.closeDialog();
    this.modalService.open(OnBoardingComponent, { size: 'lg', centered: true });
  }
  openLoginModal() {
    this.closeDialog();
    this.modalService.open(LoginComponent, { size: 'lg', centered: true });
  }

  openTermsAndConditionModal() {
    // this.closeDialog();
    this.modalService.open(TermsCondtionsComponent, { size: 'lg', centered: true });
  }

  openDisclaimerModal() {
    this.modalService.open(DisclaimerComponent, { size: 'lg', centered: true });
  }

  openPrivacyPolicyModal() {
    this.modalService.open(PrivacyPolicyComponent, { size: 'lg', centered: true });
  }

  onSubmit() {
    if (this.isCaptchaVerified === false) {
      alert("Please verify the captcha!");
      return;
    }
    this.submitted = true;
    this.signupForm.value.name.trim();
    if (this.signupForm.invalid) {
      return;
    }
    this.spinner.show();
    const params: SignUp = {
      'user': { ...this.signupForm.value }
    };
    params.user.name = params.user.name.trim();
    params.user.password = this.utilService.encode(params.user.password);
    params.user.password_confirmation = this.utilService.encode(params.user.password_confirmation);
    params.user.acceptTerms = true;

    this.authService.signUp(params).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.userData = response.data.user;
          fbq('trackCustom', 'SignUp');
          this.openConfirmEmail();
          this.signupForm.reset();
          Object.keys(this.signupForm.controls).forEach(key => {
            this.signupForm.get(key).setErrors(null) ;
          });
        }
        else if (response.status == 422) {
          this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.EMAIL_ALREADY_TAKEN;
          this.isError = true;
          this.isCaptchaVerified = false;
        }
      }, (error: any) => {
        this.spinner.hide();
        this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
        this.isError = true;
        this.isCaptchaVerified = false;
      });
  }

  signInWithFB(): void {
    // We don't need the captcha verfication for fb signup, this will return true
    this.isCaptchaVerified = true; //DON't REMOVE this line
    // console.log('here');
    this.loginService.signIn(FacebookLoginProvider.PROVIDER_ID).then(response => {
      if (response.authToken) {
        const params = {
          user: {
            email: response.email,
            facebook_id: response.id,
            name: response.name,
            provider: 'facebook',
            profile_url: response.facebook.picture.data.url
          }
        }
        if (params.user.email) {
          this.spinner.show();
          this.authService.login(params).subscribe((res) => {
            this.spinner.hide();
            if (res.body.success) {
              if (res.body.message === 'User Created') {
                fbq('trackCustom', 'SignUp');
                this.activeModal.close();
                const modalRef = this.modalService.open(OnBoardingComponent, { size: 'lg', centered: true });
                modalRef.componentInstance.profileURL = response.facebook.picture.data.url;
                modalRef.componentInstance.confirmation_token = res.body.data.user.user_confirmation_token;
              } else {
                this.setLoginData(res);
              }
            }
          }, (err) => {
            this.spinner.hide();
            this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
            this.isError = true;
            this.isCaptchaVerified = false;
          });
        } else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = 'Email is mandatory to set up a ScriptDoor account. So, Please enable email address if you have disabled it or if you have not added email to your Facebook account then add first and try again.';
          this.authService.revokeFacebookAccess(response.id, response.authToken).subscribe((revokeAccess) => {
          });
        }
      }
    });
  }


  setLoginData(response) {
    if (response.body.success) {
      const userData = response.body.data.user;
      this.userObj.id = userData['chat_sku'];
      this.userObj.name = userData['name'];
      this.userObj.username = userData['chat_sku'];
      this.userObj.email = userData['email'];
      this.userObj.author = {
        id: userData['chat_sku'],
        name: userData['name'],
        username: userData['chat_sku'],
        email: userData['email']
      };
      this.chatService.connectToSocket(this.userObj);

      OneSignal.push(() => {
        OneSignal.showSlidedownPrompt();
      });
      var element;
      element = document.querySelector('#onesignal-bell-container');
      if (element) {
        element.style.display = '';
      }
      const token = response.headers.get('Authorization');
      response.body.data['token'] = token;
      this.redirectUser(response.body.data);

      if (this.playerId)
        this.createNotificationRequest(response.body.data.user.id);

      this.activeModal.close();
      this.router.navigateByUrl(this.redirectUrl);
    }
    else if (response.body.status == 422) {
      this.spinner.hide();
      this.isError = true;
      if (response.body.errors) {
        this.errorMessage = response.body.errors;
      } else {
        this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.INVALID_EMAIL_PASSWORD;
      }
    }
    else if (response.body.status == 415 || response.body.message == 'You have to confirm your email address before continuing.') {
      this.spinner.hide();
      this.isError = true;
      this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.PLEASE_VERIFY_EMAIL;
    }
    else {
      this.spinner.hide();
      this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      this.isError = true;
    }
  }

  redirectUser(userObj) {
    // if (this.loginForm.value.rememberMe) {
    //   localStorage.setItem('rememberMe', this.loginForm.value.rememberMe);
    //   localStorage.setItem('currentUser', JSON.stringify(userObj));
    // }
    // else {
      localStorage.setItem('rememberMe', 'true');
      localStorage.setItem('currentUser', JSON.stringify(userObj));
    // }
  }

  createNotificationRequest(userId) {
    const obj = {
      device_id: this.playerId,
      plateform: 'web',
      user_id: userId
    };
    this.authService.createNotification(obj).subscribe(
      (response: any) => { });
  }

  togglePassword() {
    if (this.password == 'text') {
      this.password = 'password';
    } else {
      this.password = 'text';
    }
  }

  toggleCPassword() {
    if (this.cpassword == 'text') {
      this.cpassword = 'password';
    } else {
      this.cpassword = 'text';
    }
  }
}
